import templateUrl from 'emun.salesrep/salesrep-retailer-hold-orders.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import orderConfig from 'emun.order/order.config';

class SalesRepRetailerHoldOrdersController {
  constructor($rootScope) {
    const $ctrl = this;
    basicController($ctrl);
    var context = $ctrl.context || 'rep';
    $ctrl.orderConfig = orderConfig;
    var filter = "SalesRepID";
    if (context == 'manager') { filter = "ManagerId"; }
    if (context == 'vendor') {
      filter = "VendorId";
    } else if (context == 'subrep') {
      filter = 'SubRepId';
    }

    $ctrl.pendingOrders = new AutoQuery({
      url: 'QueryCartsJoin.json?Status=On Hold&ReasonCode=Retailer B2B Order&' + filter + '=' + this.repId,
      orderBy: '-OrderedOn',
      autoLoad: true,
      pageSize: 10,
      scrollTop: false
    })
  }
}

let SalesRepRetailerHoldOrders = {
  bindings: {
    repId: '@',
    context: '@',
  },
  controller: SalesRepRetailerHoldOrdersController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default SalesRepRetailerHoldOrders